/**
 * Module dependencies.
 */

import { Footer } from './components/footer/footer';
import { GlobalStyles } from './components/global-styles';
import { HeroSection } from './components/hero-section/hero-section';
import { ProductSection } from './components/product-section/product-section';
import { ScrollAnimation } from './components/scroll-animation/scroll-animation';
import { StepperSection } from './components/stepper-section/stepper-section';
import { VerificarLogo } from './components/verificar-logo/verificar-logo';
import styled from 'styled-components';

/**
 * `PageWrapper` styled component.
 */

const PageWrapper = styled.div`
  overflow-x: hidden;
  overflow-y: clip;
  position: relative;
  width: 100%;
`;

/**
 * Export `LandingPageComponent` component
 */

export function LandingPageComponent(): JSX.Element {
  return (
    <>
      <GlobalStyles />

      <ScrollAnimation />

      <PageWrapper>
        <HeroSection />

        <StepperSection />

        <VerificarLogo />

        <ProductSection />

        <Footer />
      </PageWrapper>
    </>
  );
}
